<template>
  <ion-page>
    <Header />
    <ion-content>
      <ion-tabs v-if="!$route.meta.public && showing" class="tabs-navigation">
        <ion-router-outlet></ion-router-outlet>
        <ion-tab-bar>
          <ion-tab-button v-if="companySelected.groupCompany === 'ore'" tab="reportMeta" @click="showReport()" >
            <!-- <ion-icon :icon="batteryDeadOutline" /> -->
            <!-- <ion-label>0%</ion-label> -->
            <ion-progress-bar class="tab-progress" v-if="!computedShowMeta" type="indeterminate"></ion-progress-bar>
            <ion-progress-bar class="tab-progress" v-if="computedShowMeta" :color="computedMetaColor" :value="computedMetaValue"></ion-progress-bar>
            <ion-label v-if="computedShowMeta" :color="computedMetaColor">
              <h6>
                {{ (computedMetaValue * 100).toFixed(0,2) }}%
              </h6>
            </ion-label>
          </ion-tab-button>
          
          <ion-tab-button tab="SC5" href="/tabs/SC5">
            <ion-icon :icon="document" />
            <ion-label>Pedidos</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="SA1" href="/tabs/SA1">
            <ion-icon :icon="person" />
            <ion-label>Clientes</ion-label>
          </ion-tab-button>

          <ion-tab-button v-if="!['manaus_automotive','cise_capital'].includes(companySelected.groupCompany)" tab="reports" href="/tabs/reports">
            <ion-icon :icon="barChart" />
            <ion-label>Relatórios</ion-label>
            <ion-badge v-if="offline" color="danger">
              <ion-icon  :icon="cloudOffline"></ion-icon>
            </ion-badge>
          </ion-tab-button>
          
          <!-- <ion-tab-button tab="tickets" href="/tabs/tickets" disabled>
            <ion-icon :icon="helpBuoyOutline" />
            <ion-label>Chamados</ion-label>
            <ion-badge v-if="offline" color="danger">
              <ion-icon  :icon="cloudOffline"></ion-icon>
            </ion-badge>
          </ion-tab-button> -->
          
        </ion-tab-bar>
      </ion-tabs>
    </ion-content>
  </ion-page>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: registersActions, mapState: registersState } = createNamespacedHelpers("registers")
import store from "../../store";
// const { mapState:authState } = createNamespacedHelpers('auth')
import {
  IonTabBar,
  IonLabel,
  IonContent,
  // IonFooter,
  // IonToolbar,
  // IonTitle,
  IonPage,
  IonProgressBar,
  IonItemDivider,
  IonIcon,
  IonTabButton,
  IonTabs,
  IonBadge,
  IonRouterOutlet,
} from "@ionic/vue";
import {
  helpBuoyOutline,
  personCircle,
  ticket,
  book,
  document,
  batteryDeadOutline,
  person,
  homeOutline,
  barChart,
  cloudOffline
} from "ionicons/icons";
import Header from "@/components/Auth/Header.vue";
import { mapState } from "vuex"

export default {
  name: "TabNavigation",
  components: {
    IonTabs,
    IonRouterOutlet,
    IonContent,
    IonPage,
    IonProgressBar,
    // IonTitle,
    // IonFooter,
    IonTabBar,
    // IonToolbar,
    // IonItemDivider,
    IonTabButton,
    IonLabel,
    IonIcon,
    IonBadge,
    Header,
  },
  data() {
    return {
      metaValue: 0,
      showMeta: false,
      idReportMeta: ''
    }
  },
  computed: {
    ...registersState(["registers"]),
    ...mapState(["offline"]),
    ...mapState(['companySelected']),
    computedMetaValue() {
      return this.metaValue
    },
    computedMetaColor() {
      if (this.metaValue < .34) {
        return 'danger'
      } else if (this.metaValue > .33 && this.metaValue < .64) {
        return 'warning'
      } else {
        return 'success'
      }
    },
    computedShowMeta() {
      return this.showMeta
    },
    computedRouteReportMeta() {
      return `reports/detalhes/${this.idReportMeta}`
    },
    showing() {
      return (
        !this.$route.path.includes("cadastrar") &&
        !this.$route.path.includes("detalhes")
      );
    },
  },
  methods:{
    ...registersActions(["getExternal", "showToast"]),
    showReport() {
      // const path = store.$router.currentRoute.value.path;
      store.$router.push(this.computedRouteReportMeta);
    },
    getQueryTotalizeMeta() {
      let query = ""
      query += "`SELECT 1 AS ID, SUM(VALOR_VENDIDO ) AS VALOR_VENDIDO, "
      query += "            SUM((VALOR_ANO_PASSADO * 1.5)) AS META"
      query += "          FROM ("
      query += "            SELECT M0_CODFIL AS D2_FILIAL, A3_COD, A3_NOME, "
      query += "              REPLICATE('0',2-LEN(MONTH_NUMBER+1)) + CONVERT(VARCHAR(2),(MONTH_NUMBER+1)) AS MES_,"
      query += "              SUM(ISNULL(D2_TOTAL-D2_VALDEV,0)) AS VALOR_VENDIDO,"
      query += "              ISNULL(("
      query += "                SELECT SUM(SD2_AP.D2_TOTAL-SD2_AP.D2_VALDEV) "
      query += "                FROM SD2${gpEmpresa} AS SD2_AP "
      query += "                INNER JOIN SC5${gpEmpresa} AS SC5_AP ON SC5_AP.D_E_L_E_T_ = '' "
      query += "                  AND SD2_AP.D2_FILIAL = SC5_AP.C5_FILIAL "
      query += "                  AND SD2_AP.D2_PEDIDO = SC5_AP.C5_NUM "
      query += "                WHERE SD2_AP.D_E_L_E_T_ = '' "
      query += "                  AND SD2_AP.D2_FILIAL = M0_CODFIL "
      query += "                  AND LEFT(SD2_AP.D2_EMISSAO,4) = '${(new Date()).getFullYear() - 1}' "
      query += "                  AND CONVERT(INT,SUBSTRING(SD2_AP.D2_EMISSAO,5,2)) = (MONTH_NUMBER +1)"
      query += "                  AND SC5_AP.C5_VEND1 = TEMP1.A3_COD"
      query += "                  AND SD2_AP.D2_TIPO NOT IN ( 'D' , 'B' ,'I'  )"
      query += "              ),0) AS VALOR_ANO_PASSADO"
      query += "            FROM ("
      query += "              SELECT DISTINCT TRIM(M0_CODFIL) AS M0_CODFIL, s.number AS MONTH_NUMBER, A3_COD, A3_NOME"
      query += "              FROM SYS_COMPANY AS SM0, [master].[dbo].[spt_values] AS s, SA3${gpEmpresa} AS SA3"
      query += "              WHERE [type] = 'P' "
      query += "              AND s.number BETWEEN 0 AND 11"
      query += "              AND A3_FILIAL = '' AND A3_COD NOT IN ('000100', '000203', '000211')"
      query += "            ) AS TEMP1"
      query += "            LEFT OUTER JOIN SC5${gpEmpresa} AS SA3 ON SA3.D_E_L_E_T_ = '' "
      query += "              AND M0_CODFIL = C5_FILIAL"
      query += "              AND A3_COD = C5_VEND1"
      query += "            LEFT OUTER JOIN SD2${gpEmpresa} AS SD2 ON SD2.D_E_L_E_T_ = ''"
      query += "              AND D2_FILIAL = C5_FILIAL "
      query += "              AND D2_PEDIDO = C5_NUM  "
      query += "              AND LEFT(D2_EMISSAO,4) = '${(new Date()).getFullYear()}'"
      query += "              AND CONVERT(INT, SUBSTRING(D2_EMISSAO,5,2)) = (MONTH_NUMBER+1)"
      query += "              AND D2_TIPO NOT IN ( 'D' , 'B' ,'I'  ) "
      query += "            WHERE (1 = ${(user.superAdmin || admin) ? 1 : 0} OR "
      query += "              ("
      query += "                A3_COD IN ("
      query += "                  SELECT A3_COD FROM SA3${gpEmpresa} AS SA3_A WHERE SA3_A.D_E_L_E_T_ = '' AND A3_FILIAL = '' "
      query += "                      AND (SELECT A3_COD FROM SA3${gpEmpresa} AS SA3_B WHERE SA3_B.D_E_L_E_T_ = '' AND A3_FILIAL = '' AND A3_USRPORT = '${user.uid}') IN (A3_COD, A3_SUPER, A3_GEREN)"
      query += "                  )"
      query += "              )) AND M0_CODFIL IN (${ register.trim() === 'meta_totalize' ? \"'\" + filial +\"'\" : [\"'0101'\",\"'0102'\",\"0201\",\"0301\"]}) "
      query += "                      AND (${ register === 'meta_totalize' ? (`MONTH_NUMBER = ${(new Date()).getMonth()}`) : '1 = 1' })"
      query += "                  ${queryFilter}"
      query += "            GROUP BY M0_CODFIL, MONTH_NUMBER, A3_COD, A3_NOME"
      query += "          ) AS TEMP"
      query += "          WHERE 1 = 1"
      query += "      `"
      return query;
    },
  },
  created() {
    this.showMeta = false;
    if (this.companySelected.groupCompany === 'ore') {
      const report = this.registers.reports ? 
        this.registers.reports.find(r => r.name && r.name.toLowerCase().includes('meta venda faturada'))
        : null
      if (!report) return

      // const { dataTables, id: idReport } = report
      const { id: idReport } = report

      this.idReportMeta = idReport
      
      // const { queryTotalize } = dataTables[0]

      const queryTotalize = this.getQueryTotalizeMeta()

      const totalizeRequest = {query: queryTotalize, register: `meta_totalize`, filters: [], ordem: 'ID ASC', perPage: 1, async: true, setRegister: false, isRestNode: false}
      this.getExternal(totalizeRequest)
      .then((res)=>{
        if (res && res.length > 0) {
          const result = res[0]
          this.metaValue = (result['VALOR_VENDIDO']*1) / (result['META']*1);
          this.showMeta = true;
        }        
      })
    }
  },
  setup() {
    return {
      helpBuoyOutline,
      batteryDeadOutline,
      personCircle,
      document,
      person,
      homeOutline,
      barChart,
      ticket,
      book,
      cloudOffline
    };
  },
};
</script>
<style>
  .tabs-navigation {
    margin: 0px!important;
    padding: 0px!important;
  }
  .ion-footer-version {
    font-size: .6em;
    background: var(--ion-tab-bar-background);
    color: grey;
  }
  
  ion-progress-bar.tab-progress {
    height: 5px!important;
    margin-top: 1em!important;
    margin-bottom: .25em!important;
  }
</style>